import dynamic from 'next/dynamic';
import { ContactInfoMobileOverlayProps } from './ContactInfoMobileOverlay';

export const DynamicContactInfoMobileOverlay =
    dynamic<ContactInfoMobileOverlayProps>(() =>
        import('./ContactInfoMobileOverlay').then(
            md => md.ContactInfoMobileOverlay,
        ),
    );
